/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Restaurant = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.8 4V4.75V6.53004C17.3542 6.91248 21.1 10.8983 21.3 15.75V16.5H20.55H3.55H2.8V15.75C2.6 10.8983 6.3458 6.91248 11.3 6.53004V4.75V4H12.8ZM19.7641 15C19.1861 11.0753 15.8728 8 12.05 8C7.8272 8 4.51393 11.0753 4.33593 15H19.7641ZM2 18.25V19.75H22V18.25H2Z"
                        fill={color}
                    />
                </svg>
        );
    };
